export const features = [
  {
    id: 1,
    title: "It maintains your health",
    description:
      "IMPROPER execution is going to decrease the effectiveness of the training stimulus and increase the risk of injury.",
    icon: "star_rate_icon",
  },
  {
    id: 2,
    title: "Customized",
    description:
      "Our AI powered fitness app will guide you with the best program to help you get a healthy and ideal body.",
    icon: "beenhere_icon",
  },
  {
    id: 3,
    title: "Easy to Use",
    description:
      "Our AI powered fitness app will guide you with the best program to help you get a healthy and ideal body.",
    icon: "auto_mode_icon",
  },
];

export const testimonial = [
  {
    id: 1,
    name: "Aditya Borkar",
    description:
      "Great application.. you can do your workout at home with correct form and counting.. so there is less chance to get injury.. I suggest everyone to use this app.. Thank you",
    role: "Fitness Trainer",
  },
  {
    id: 2,
    name: "Sahil Bhavsar",
    description:
      "This app is amazing 😍 it's very beneficial for those who is not hiring trainer for workout at gym infact it's good 😊 and nice app",
    role: "Gym Trainee",
  },
  {
    id: 3,
    name: "Omkar",
    description:
      "As an active gym person, sometime it gets very difficult to count our reps on a particular heavy set that too keeping a good form, this project will help to counter the issue. Also the body tracking feature makes it even more accurate to work on our form.",
    role: "Weight Lifter",
  },
];

export const homePageDiet = [
  {
    id: 1,
    title: "Diet Meal Plan to Lose Weight",
    route: "/weightloss",
    description:
      "This easy 1,500-calorie weight-loss meal plan is specially tailored to help you feel energized .",
    image:
      "https://images.pexels.com/photos/4929677/pexels-photo-4929677.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 2,
    title: "Diet Meal Plan to Gain Weight",
    route: "/weightgain",
    description:
      "Gain weight the healthy way with this nutrient-packed meal plan.",
    image:
      "https://images.pexels.com/photos/4929692/pexels-photo-4929692.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 3,
    title: "Healthy Eating Plate",
    route: "/healthy",
    description:
      "Use the Healthy Eating Plate as a guide for creating healthy, balanced meals—whether served at the table or packed in a lunch box.",
    image:
      "https://images.pexels.com/photos/793765/pexels-photo-793765.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
];

export const HomePageActivity = [
  {
    id: 1,
    title: "Yoga",
    route: "/yoga",
    description:
      "Yoga is a group of physical, mental, and spiritual practices or disciplines.",
    image:
      "https://images.pexels.com/photos/9271215/pexels-photo-9271215.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 2,
    title: "Strength Training",
    route: "/workout",
    description:
      "Strength training is a type of physical exercise specializing in the use of resistance to induce muscular contraction.",
    image:
      "https://images.pexels.com/photos/10360933/pexels-photo-10360933.jpeg?auto=compress&cs=tinysrgb&w=500",
  },
];

export const YogaVariation = [
  {
    id: 1,
    title: "Virabhadrasana",
    route: "/virabhadrasana",
    description:
      "Vira which means courageous, warrior or vigorous; Badra means auspicious or good, while asana refers to posture.",
    image:
      "https://images.squarespace-cdn.com/content/v1/5f35301faed3a85bf80f77ed/1600440219305-RZTH2MR2SAW2HWNGMUNG/img_news1.jpg",
  },
  {
    id: 2,
    title: "Trikonasana",
    route: "/trikonasana",
    description:
      "Trikonasana or Utthita Trikonasana, [Extended] Triangle Pose is a standing asana in modern yoga as exercise.",
    image:
      "https://images.pexels.com/photos/5384538/pexels-photo-5384538.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 3,
    title: "AdhoMukhaSvanasana",
    route: "/adhomukhasvanasana",
    description:
      "Adho Mukha Svanasana is a yoga asana that is commonly translated as Downward-Facing Dog Pose.",
    image: "https://www.yogateket.com/image/original/downwardfacingdog.jpg",
  },
];

export const WorkoutVariation = [
  {
    id: 1,
    title: "Push Up",
    route: "/pushups",
    description:
      "A push-up is a common calisthenics exercise beginning from the prone position. By raising and lowering the body using the arms.",
    image:
      "https://images.pexels.com/photos/2780762/pexels-photo-2780762.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 2,
    title: "Squat",
    route: "/squats",
    description:
      "A squat is a strength exercise in which the trainee lowers their hips from a standing position and then stands back up.",
    image:
      "https://images.pexels.com/photos/6998874/pexels-photo-6998874.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 3,
    title: "Crunches",
    route: "/crunches",
    description:
      "A crunch is a abdominal exercise in a strength-training program. It targets the rectus abdominis muscle.",
    image:
      "https://images.pexels.com/photos/5262853/pexels-photo-5262853.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 4,
    title: "Bicep Curls",
    route: "/bicepcurls",
    description:
      "A biceps curl is an exercise used in weight training and bodybuilding in which the trainee performs a curling motion with a dumbbell or barbell while standing up.",
    image:
      "https://images.pexels.com/photos/7188078/pexels-photo-7188078.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
];

export default features;
